<template>
  <div class="login_page fillcontain">
    <transition name="form-fade" mode="in-out">
      <section class="form_contianer">
        <div class="manage_tip">
          <p>手抄报老师后台管理系统</p>
        </div>
        <el-form :model="loginForm" :rules="rules" ref="loginForm">
          <el-form-item prop="username">
            <el-input v-model="loginForm.username" placeholder="用户名" style="width: 100%!important;"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" placeholder="密码" v-model="loginForm.password" style="width: 100%!important;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('loginForm')" class="submit_btn">登录</el-button>
          </el-form-item>
        </el-form>
      </section>
    </transition>
  </div>
</template>

<script>
  import { getlogin,getJurisdiction } from '../api/api';
  export default {
    data(){
      return {
        loginForm: {
          username: '',
          password: '',
        },
        rules: {
          username: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ],
        },
      }
    },
    mounted(){
    },
    methods: {
      submitForm(){
        let params={
          account:this.loginForm.username,
          password:this.loginForm.password,
        };
        //登陆
        getlogin(params).then(res=>{
          if (res.state == true) {
            this.$message({
              type: 'success',
              message: res.msg
            });
            let data = res.data
            this.$store.commit('set_token', data["token"]);
            sessionStorage.setItem('user', JSON.stringify(res.data));
            getJurisdiction({operationId:JSON.parse(sessionStorage.getItem('user')).id}).then(res=>{
              if (res[0].children.length == 0){
                if (res[0].url == null){
                  this.$router.push('/empty')
                } else {
                  this.$router.push(res[0].url)
                }
              } else {
                this.$router.push(res[0].children[0].url)
              }

            }).catch(error=>{
              console.log(error);
            })
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            });
          }
        }).catch(error=>{
          console.log(error);
        })
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '../style/mixin';
  .login_page{
    background-color: #324057;
  }
  .manage_tip{
    position: absolute;
    width: 100%;
    top: -100px;
    left: 0;
    p{
      font-size: 32px;
      color: #fff;
    }
  }
  .form_contianer{
    .wh(320px, 210px);
    .ctp(320px, 210px);
    padding: 25px;
    border-radius: 5px;
    text-align: center;
    background-color: #fff;
    .submit_btn{
      width: 100%;
      font-size: 16px;
    }
  }
  .tip{
    font-size: 12px;
    color: red;
  }
  .form-fade-enter-active, .form-fade-leave-active {
    transition: all 1s;
  }
  .form-fade-enter, .form-fade-leave-active {
    transform: translate3d(0, -50px, 0);
    opacity: 0;
  }

</style>




// WEBPACK FOOTER //
// src/page/login.vue